// Central site facts — single source of truth for contact details, hours, links.
export const SITE = {
  name: "Lulu Wild",
  domain: "https://luluwild.co.uk",
  tagline: "Chinese restaurant & cocktail bar in Brindleyplace, Birmingham",
  phone: "0121 6311739",
  phoneHref: "tel:+441216311739",
  email: "info@luluwild.co.uk",
  address: {
    street: "Unit 7 & 8 The Waters Edge, Brindleyplace",
    city: "Birmingham",
    postcode: "B1 2HP",
    country: "GB",
  },
  geo: { lat: 52.4794, lng: -1.9124 },
  hours: [
    { days: "Monday – Thursday", time: "12pm – 11pm" },
    { days: "Friday", time: "12pm – 2am" },
    { days: "Saturday", time: "12pm – 2am" },
    { days: "Sunday", time: "12pm – 11pm" },
  ],
  openingHoursSpec: [
    { dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday"], opens: "12:00", closes: "23:00" },
    { dayOfWeek: ["Friday", "Saturday"], opens: "12:00", closes: "02:00" },
    { dayOfWeek: ["Sunday"], opens: "12:00", closes: "23:00" },
  ],
  social: {
    instagram: "https://www.instagram.com/luluwilduk/",
    facebook: "https://www.facebook.com/luluwilduk",
  },
  booking: {
    // OpenTable's loader script, copied exactly from the live luluwild.co.uk/reservations/ (2026-10-20). It
    // replaced the old /widget/reservation/mural iframe after OpenTable's email; see components/OpenTableWidget.js.
    opentableLoader:
      "https://www.opentable.co.uk/widget/reservation/loader?rid=260268&type=standard&theme=standard&domain=couk&lang=en-GB&newtab=false&ot_source=Restaurant%20website&color=8&dark=false&ot_logo=subtle&primary_color=000000&primary_font_color=ffffff&button_color=E68B61&button_font_color=ffffff&iframe=true&cfe=true",
    opentableRestaurant: "https://www.opentable.co.uk/r/lulu-wild-birmingham",
  },
  giftCards: "https://luluwild.giftpro.co.uk/",
  web3formsKey: "2ca12a60-0468-4aa1-83b6-d652cbea9742",
  // Klaviyo: company (public site ID) and the "subscribers" list her live sign-up forms feed
  // (read from the live form config, 2026-10-16). Opt-in boxes on every form add people here.
  klaviyo: { companyId: "S4hgFg", listId: "VJVBx7" },
  // Absolute base for Web3Forms redirects (it needs a full URL). Live domain since 2026-10-22.
  formBase: "https://luluwild.co.uk",
  logo: "/media/2021/07/Artboard-18@2x.png",
  mapEmbed:
    "https://www.google.com/maps/embed/v1/place?key=&q=Lulu+Wild,+Brindleyplace,+Birmingham" ,
  mapsLink: "https://maps.google.com/?q=Lulu+Wild,+The+Waters+Edge,+Brindleyplace,+Birmingham+B1+2HP",
};

// Nav spotlight: first item in the main nav, plain styling. Swap it for
// whatever Lulu is pushing (Christmas, a new menu, private hire). Set to null
// to hide it.
export const SPOTLIGHT = { label: "Christmas", href: "/christmas/" };
